"use client";

import { Leaf, Hammer, MapPin, Shuffle, Ruler } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function MemberBenefits() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const pillars = [{
    number: "01",
    name: "Seed Swapping",
    description: "Exchange heirloom varieties with neighbors to preserve biodiversity and ensure our community garden thrives with unique, resilient crops.",
    Icon: Shuffle
  }, {
    number: "02",
    name: "Organic Workshops",
    description: "Learn sustainable farming techniques from local experts, covering everything from soil health to natural pest management for your plot.",
    Icon: Hammer
  }, {
    number: "03",
    name: "Plot Guidelines",
    description: "Clear, shared standards for maintenance and composting that keep our collective space beautiful, productive, and welcoming for everyone.",
    Icon: Ruler
  }];
  return <section data-section-id="4707" id="member-benefits" className="dark bg-background text-foreground py-24 md:py-40 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="text-sm font-mono uppercase tracking-[0.25em] text-primary mb-8">
            Club Features
          </span>
          <h2 className="font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.1] font-light text-foreground max-w-3xl">
            Growing together.
          </h2>
        </div>

        {}
        <div className="hidden md:grid grid-cols-3 gap-16 items-start">
          {pillars.map((pillar, i) => {
          const {
            ref,
            isVisible
          } = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.2
          });
          const Icon = pillar.Icon;
          const offsetClass = i === 1 ? "mt-24" : "mt-0";
          return <div data-index={i} key={i} ref={ref} className={`${offsetClass} flex flex-col transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 200}ms`
          }}>
                <span className="font-mono text-sm uppercase tracking-[0.25em] text-primary mb-12">
                  {pillar.number}
                </span>

                <div className={`mb-20 transition-all duration-1500 ease-out ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}`} style={{
              transitionDelay: `${i * 200 + 300}ms`
            }}>
                  <Icon className="w-20 h-20 text-foreground" strokeWidth={0.75} aria-hidden="true" />
                </div>

                <h3 className="font-default text-3xl font-light text-foreground mb-6 leading-tight">
                  {pillar.name}
                </h3>
                <p className="font-default text-[15px] leading-relaxed text-muted-foreground max-w-xs">
                  {pillar.description}
                </p>
              </div>;
        })}
        </div>

        {}
        <div className="md:hidden flex flex-col">
          {pillars.map((pillar, i) => {
          const Icon = pillar.Icon;
          return <div data-index={i} key={i} className="flex flex-col py-12 first:pt-0 last:pb-0">
                <span className="font-mono text-sm uppercase tracking-[0.25em] text-primary mb-8">
                  {pillar.number}
                </span>
                <div className="mb-10">
                  <Icon className="w-16 h-16 text-foreground" strokeWidth={0.75} aria-hidden="true" />
                </div>
                <h3 className="font-default text-3xl font-light text-foreground mb-4 leading-tight">
                  {pillar.name}
                </h3>
                <p className="font-default text-[15px] leading-relaxed text-muted-foreground">
                  {pillar.description}
                </p>
                {i < pillars.length - 1 && <Separator className="mt-12 bg-border" />}
              </div>;
        })}
        </div>
      </div>
    </section>;
}